import Ajax from './ajax';
import { LOGGED_OFF } from './authentication';
import Warehouse from '../domain/warehouse';
import { cloneDeep } from 'lodash';
import WarehouseInventoryItem from '../domain/warehouseinventoryitem';

export const LOADING_WAREHOUSES = 'warehousedata/LOADING';
export const WAREHOUSES_LOADED = 'warehousedata/LOADED';
export const WAREHOUSED_SAVED = 'warehousedata/SAVED';
export const WAREHOUSE_FULL_LOADED = 'warehousedata/FULL_LOADED';
export const WAREHOUSE_USER_SAVED = 'warehousedata/USER_SAVED';
export const WAREHOUSE_USER_REMOVED = 'warehousedata/WAREHOUSE_USER_REMOVED';
export const WAREHOUSE_INVENTORY_ITEM_UPDATED = 'warehousedata/WAREHOUSE_INVENTORY_ITEM_UPDATED';
export const WAREHOUSE_INVENTORY_ITEM_REMOVED = 'warehousedata/WAREHOUSE_INVENTORY_ITEM_REMOVE';

const initialState = {
    fetchingData: false,
    warehouses: null,
    warehousesById: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_WAREHOUSES: {
            return {
                ...state,
                fetchingData: true,
                surveys: null,
            };
        }
        case WAREHOUSES_LOADED: {
            let newData = [];
            for (let w of action.warehouses) {
                newData.push(new Warehouse(w));
            }
            return {
                ...state,
                warehouses: newData,
                fetchingData: false,
            };
        }
        case WAREHOUSE_FULL_LOADED: {
            let newData = cloneDeep(state.warehousesById);
            newData[action.warehouse.id] = new Warehouse(action.warehouse);
            return {
                ...state,
                warehousesById: newData,
            };
        }
        case WAREHOUSED_SAVED: {
            if (!action.warehouse) return state;
            let newData = cloneDeep(state.warehousesById);
            newData[action.warehouse.id] = new Warehouse(action.warehouse);

            // Also update the warehouses array if present
            let newList = cloneDeep(state.warehouses);
            if (Array.isArray(state.warehouses)) {
                if (state.warehouses.findIndex((w) => w.id === action.warehouse.id) === -1) {
                    newList.push(new Warehouse(action.warehouse));
                } else {
                    newList = state.warehouses.map((w) =>
                        w.id === action.warehouse.id ? new Warehouse(action.warehouse) : w
                    );
                }
            }

            return {
                ...state,
                warehousesById: newData,
                warehouses: newList,
            };
        }
        case WAREHOUSE_USER_SAVED: {
            if (!action.user || !action.user.warehouseIds) return state;
            const wid = action.user.warehouseIds[0];

            const newData = cloneDeep(state.warehousesById);
            if (newData.hasOwnProperty(wid)) {
                newData[wid].users.push(action.user);
            }

            return {
                ...state,
                warehousesById: newData,
            };
        }
        case WAREHOUSE_USER_REMOVED: {
            const newData = cloneDeep(state.warehousesById);
            if (newData[action.warehouseId]) {
                const ind = newData[action.warehouseId].users.findIndex((u) => u.clusterId === action.userId);
                if (ind > -1) {
                    newData[action.warehouseId].users.splice(ind, 1);
                }
            }

            return {
                ...state,
                warehousesById: newData,
            };
        }
        case WAREHOUSE_INVENTORY_ITEM_UPDATED: {
            const newData = cloneDeep(state.warehousesById);
            if (newData[action.inventoryItem.warehouseId]) {
                const item = newData[action.inventoryItem.warehouseId].inventory.find(
                    (it) => it.itemId === action.inventoryItem.itemId
                );

                if (item) {
                    if (item.itemType === WarehouseInventoryItem.TypeFolder()) {
                        item.itemName = action.inventoryItem.itemName;
                    } else {
                        item.netQuantity = action.inventoryItem.netQuantity;
                        item.lowThreshold = action.inventoryItem.lowThreshold;
                        item.parentFolderId = action.inventoryItem.parentFolderId;
                    }
                } else {
                    newData[action.inventoryItem.warehouseId].inventory.push(
                        new WarehouseInventoryItem(action.inventoryItem)
                    );
                }
            }
            return {
                ...state,
                warehousesById: newData,
            };
        }
        case WAREHOUSE_INVENTORY_ITEM_REMOVED: {
            const newData = cloneDeep(state.warehousesById);
            if (newData[action.inventoryItem.warehouseId]) {
                const index = newData[action.inventoryItem.warehouseId].inventory.findIndex(
                    (it) => it.itemId === action.inventoryItem.itemId
                );
                if (index > -1) {
                    newData[action.inventoryItem.warehouseId].inventory.splice(index, 1);
                }
            }
            return {
                ...state,
                warehousesById: newData,
            };
        }
        case LOGGED_OFF:
            return initialState;
        default:
            return state;
    }
};

export const loadWarehouses = () => {
    return async (dispatch) => {
        dispatch({
            type: LOADING_WAREHOUSES,
        });
        try {
            var resp = await Ajax.get('api/warehouse/');
            dispatch({ type: WAREHOUSES_LOADED, warehouses: resp.data });
        } catch (err) {
            console.log(err);
            dispatch({ type: WAREHOUSES_LOADED, warehouses: null });
        }
    };
};

export const saveWarehouse = (warehouse) => {
    return async (dispatch) => {
        try {
            var resp = await Ajax.post('api/warehouse', warehouse);
            dispatch({ type: WAREHOUSED_SAVED, warehouse: resp.data });
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const getWarehouseFull = (id) => {
    return async (dispatch) => {
        try {
            var resp = await Ajax.get('api/warehouse/' + id);
            dispatch({ type: WAREHOUSE_FULL_LOADED, warehouse: resp.data });
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const saveNewUser = (user) => {
    return async (dispatch) => {
        try {
            var resp = await Ajax.post(`api/warehouse/${user.warehouseId}/user`, user);
            dispatch({ type: WAREHOUSE_USER_SAVED, user: resp.data });
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const removeUser = (userId, warehouseId) => {
    return async (dispatch) => {
        try {
            await Ajax.delete(`api/warehouse/${warehouseId}/user/${userId}`);
            dispatch({ type: WAREHOUSE_USER_REMOVED, userId, warehouseId });
            return true;
        } catch (err) {
            console.log(err);
            return false;
        }
    };
};

export const updateLowThreshold = (inventoryItem) => {
    return async (dispatch) => {
        try {
            await Ajax.put('api/warehouse/updatelowthreshold', inventoryItem);
            dispatch({ type: WAREHOUSE_INVENTORY_ITEM_UPDATED, inventoryItem });
        } catch (err) {
            console.log(err);
        }
    };
};

export const updateStock = (inventoryItem) => {
    return async (dispatch) => {
        try {
            await Ajax.put('api/warehouse/updatestock', inventoryItem);
            dispatch({ type: WAREHOUSE_INVENTORY_ITEM_UPDATED, inventoryItem });
        } catch (err) {
            console.log(err);
        }
    };
};

export const upsertInventoryFolder = (folderItem) => {
    return async (dispatch) => {
        try {
            await Ajax.put('api/warehouse/folder', folderItem);
            dispatch({ type: WAREHOUSE_INVENTORY_ITEM_UPDATED, inventoryItem: folderItem });
        } catch (err) {
            console.log(err);
        }
    };
};

export const updateFolderLink = (item) => {
    return async (dispatch) => {
        try {
            await Ajax.put('api/warehouse/updatefolderlink', item);
            dispatch({ type: WAREHOUSE_INVENTORY_ITEM_UPDATED, inventoryItem: item });
        } catch (err) {
            console.log(err);
        }
    };
};

export const removeProduct = (item) => {
    return async (dispatch) => {
        try {
            await Ajax.delete(`api/warehouse/${item.warehouseId}/${item.itemType}/${item.itemId}`);
            dispatch({ type: WAREHOUSE_INVENTORY_ITEM_REMOVED, inventoryItem: item });
        } catch (err) {
            console.log(err);
        }
    };
};
